
const paymentStatus = {
    PAID: "paid",
    UNPAID: "unpaid",
    PASSED_DUE: "passedDue"
}

const getInvoicePaymentStatus = (invoice) => {
    if(invoice.IsPaid) {
        return paymentStatus.PAID;
    }

    const dueDate = new Date(invoice.DueDate);
    const now = new Date();

    if((dueDate - now) > 0) {
        return paymentStatus.UNPAID;
    } else {
        return paymentStatus.PASSED_DUE;
    }
}

const getInvoiceByStatus = (invoiceList) => {
    const byStatus = {
        [paymentStatus.PAID]: [],
        [paymentStatus.UNPAID]: [],
        [paymentStatus.PASSED_DUE]: []
    };

    for(const inv of invoiceList) {
        const status = invoiceService.getInvoicePaymentStatus(inv);
        byStatus[status].push(inv);
    }

    return byStatus;
}

export const invoiceService = {
    paymentStatus,
    getInvoicePaymentStatus,
    getInvoiceByStatus,
}